import Vue from 'vue';
import Introduction from '../../components/Introduction';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#introduction',
  components: { Introduction },
  template: '<Introduction/>'
})



// WEBPACK FOOTER //
// ./src/pages/about/introduction.js